import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import TextField from '@mui/material/TextField';
//import {Stack, Snackbar, Alert, LinearProgress } from '@mui/material';
import {Stack, Snackbar, Alert, LinearProgress, DialogContentText} from '@mui/material';
// import InputLabel from '@mui/material/InputLabel';
// import MenuItem from '@mui/material/MenuItem';
// import FormControl from '@mui/material/FormControl';
// import Select from '@mui/material/Select';
// import Stack from '@mui/material/Stack';
// import Snackbar from '@mui/material/Snackbar';
// import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@mui/material/DialogActions';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import Cookies from 'js-cookie';
import TreeViewTopics from './TreeViewTopics'; 
import TempTopicSave from './TempTopicSave';
import CheckAvailability from '../checkavailability/CheckAvailability';
//import TempTopicDisplayNames from './TempTopicDisplayNames';
import TreeCopyFromSave from './TreeCopyFromSave';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const userObj = useSelector(state => state.userDetails);
  const childRefSave = React.useRef();
  const childRefCopyFrom = React.useRef();
  const [open, setOpen] = React.useState(false);
  const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);  
  const [deleteBtnLoading, setDeleteBtnLoading] = React.useState(false);
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [pageLoading, setPageLoading] = React.useState(true); 
  const [addBtnLoading, setAddBtnLoading] = React.useState(false);
  const [uplineFlagLoading, setUplineFlagLoading] = React.useState(false);
  //const [saveBtn, setSaveBtn] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  const [keyword, setKeyword] = React.useState("BIO");
  const [tempTreeview, setTempTreeview] = React.useState([]);
  const [selectedIndex, setSelectedIndex] = React.useState(-1);
  const [topicListObj, setTopicListObj] = React.useState({});

  const [treeTopicObj, setTreeTopicObj] = React.useState({});
  const [idNum, setIdNum] = React.useState(100000);

  const handleListItemClick = (event, index, obj) => {
    setSelectedIndex(index);
    setTopicListObj(obj);
  };

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}


  React.useEffect(() => {	
    setTempTreeview([]);
    //setSaveBtn(false);
    setPageLoading(true);
    setSelectedIndex(-1);
    setTreeTopicObj({});
    if(open && props.dataObj && props.dataObj.autoId){	
      getApiDataTopicList();
      getApiDataTopicTreeview();
    }
	}, [props.dataObj,userObj,open]);

  async function getApiDataTopicList(){
		///alert(userObj.token);
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 
			setPageLoading(true);
			axios.get(env.API_URL+"/topic-service/read/list?sortby=topicName", axiosHeader) 
			   .then(response => {
				 setPageLoading(false); 
				if(response.data && response.data.responseTxt==="invalidToken"){ 
					Cookies.remove('isadminloggedin');
					window.location.href='login';
				// }else if(response.data && response.data.responseTxt==="NoAuthorization"){ 
				// 	childRefAuthorization.current.handleClickOpen();
				}else if(response.data && response.data.responseTxt==="success"){
					setRows(response.data.obj.list);
					///setPrivileges(response.data.privileges);
				}		
			})
			// .catch((error) => {
			// 	alert("ERROR: ", error);
			// })	
	}

  async function getApiDataTopicTreeview(){
		///alert(userObj.token);
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 
			setPageLoading(true);
			axios.get(env.API_URL+"/topic-service/read/topics-templates-treeview?templateId="+props.dataObj.autoId, axiosHeader) 
			   .then(response => {
				 setPageLoading(false); 
				if(response.data && response.data.responseTxt==="invalidToken"){ 
					Cookies.remove('isadminloggedin');
					window.location.href='login';
				}else if(response.data && response.data.responseTxt==="success"){
          //document.write(JSON.stringify(response.data.obj.map["Default"]));
          setTempTreeview(response.data.obj.list);
				}		
			})
			// .catch((error) => {
			// 	alert("ERROR: ", error);
			// })	
	}

  function unselectTopic() {
    setTreeTopicObj({});
  }

  function editTopic() {
    childRefSave.current.handleClickOpen();
  } 

	// function addTopic(){    
    
  //   if(selectedIndex<0){
  //     setSeverityAlert("error");
  //     setShowAlert(true);
  //     setAlertMessage("Select topic name");			
  //     return false;
  //   }  
  //   //let checkNodeVal = checkNodeExists(tempTreeview, topicListObj.topicName);
  //   //if(!checkNodeVal){
  //     addNode(treeTopicObj?.id,newNode);
  //   //}

  // }

	function addTopic(){    
    
    if(selectedIndex<0){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select topic name");			
      return false;
    }  

		if(selectedIndex>-1 && rows && rows.length>0 && topicListObj && topicListObj.autoId>0){ 
      setAddBtnLoading(true);
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'	
				}
			}; 
			const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('templateId', props.dataObj.autoId);
        data.append('topicId', topicListObj.autoId);
        data.append('topicName', topicListObj.topicName);        
        if(treeTopicObj.id>0){
          data.append('parentId', treeTopicObj.id);
          data.append('subjectId', treeTopicObj.subjectId);
          data.append('subject', treeTopicObj.subjectName);
        }else{
          data.append('parentId', 0);
          data.append('subjectId', 0);
          data.append('subject', '');
        }
      }

			axios.post(env.API_URL+'/topic-service/create/topics-templates-treeview', data, axiosHeader)
			.then((response) => {
        setAddBtnLoading(false);
				//console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){    
          
          const newNode = {
            id: response.data.obj.id, 
            templateId: response.data.obj.templateId,
            topicId: response.data.obj.topicId,
            title: response.data.obj.topicName, 
            topicName: response.data.obj.topicName, 
            parentId: (response.data.obj.parentId || 0),
            subjectId: (response.data.obj.subjectId || 0),
            subjectName: (response.data.obj.subjectName || ''),
            display: 1,
            sequence: response.data.obj.sequence,
            children: []
          }
      
          addNode(treeTopicObj?.id,newNode);
          
          setSeverityAlert("success");          
					setShowAlert(true);
					setAlertMessage("Topic name: "+topicListObj.topicName+" has been added.");
          // setTempTreeview(response.data.obj.list);
          setSelectedIndex(-1);
          ///setSaveBtn(true);
          //updateCache(); //update cache in DB
					return false;
          
        }else if(response.data.responseTxt==="noSubjectFound"){
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("No subject found");			
					return false;  

        }else if(response.data.responseTxt==="alreadyexistserror"){
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Already added.");			
					return false;  

				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Topic could not be added.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("ERROR: ", error);
			})	
		}		
	}

  // function updateCache_x(){    
  //   if(tempTreeview && tempTreeview.length>0){
 	// 		let axiosHeader = {
	// 			headers: {
	// 				'Content-Type': 'multipart/mixed',
	// 				'loginId': userObj.loginId,
	// 				'token': userObj.token,
	// 				'device': 'web'	
	// 			}
	// 		}; 
	// 		const data = new FormData();
  //     if(props.dataObj && props.dataObj.autoId){
  //       data.append('templateId', props.dataObj.autoId);
  //       data.append('jsonStr', JSON.stringify(tempTreeview));
  //     }
	// 		axios.post(env.API_URL+'/topic-service/update/topics-update-treeviewjson', data, axiosHeader)
	// 		.then((response) => {
	// 			//console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
	// 			if(response.data.responseTxt==="success"){    
	// 				return false;
  //       }
	// 		})
	// 		.catch((error) => {
	// 			console.log("ERROR: ", error);
	// 		})	
  //   }	
	// }

  function updateUDFlag(){    
    if(tempTreeview && tempTreeview.length>0){
 			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'	
				}
			}; 
			const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('templateId', props.dataObj.autoId);
        ///data.append('jsonStr', JSON.stringify(tempTreeview));
      }
      setUplineFlagLoading(true);
			axios.post(env.API_URL+'/topic-service/upline/topics-treeview-upline', data, axiosHeader)
			.then((response) => {
        setUplineFlagLoading(false);
				if(response.data.responseTxt==="success"){   
          if(response.data.obj && response.data.obj.length>0){
            setTempTreeview(response.data.obj);
          } 
					return false;
        }
			})
			.catch((error) => {
				console.log("ERROR: ", error);
			})	
    }	
	}

  // function deleteTopic(){
  //   if(!treeTopicObj){
  //     setSeverityAlert("error");
  //     setShowAlert(true);
  //     setAlertMessage("Select any tree node to remove");			
  //     return false;
  //   }

  //   delNode(treeTopicObj?.id);
  //   setDeleteDialogShow(false);
  // }

  function deleteTopic(){    
    
    if(!treeTopicObj){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select any tree node to remove");			
      return false;
    }  
    
		if(treeTopicObj && treeTopicObj.id>0){ 
      setDeleteBtnLoading(true);
      
      

      let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'	
				}
			}; 
			const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('templateId', props.dataObj.autoId);
        data.append('id', treeTopicObj.id);
      }      
			axios.post(env.API_URL+'/topic-service/delete/topics-templates-treeview', data, axiosHeader)
			.then((response) => {
        setDeleteBtnLoading(false);
				//console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setTreeTopicObj({});
          setDeleteDialogShow(false);
          setSeverityAlert("success");          
					setShowAlert(true);
          if(treeTopicObj){
					  setAlertMessage(treeTopicObj.title+" has been removed.");
          }else{
            setAlertMessage("Topic has been removed.");
          }
          delNode(treeTopicObj?.id);
          ///setTempTreeview(response.data.obj.list);
          ///setSaveBtn(true);  
          //updateCache(); //update cache in DB after delete      
					return false;
				}else{
          setDeleteDialogShow(false);
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Topic could not be removed.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("ERROR: ", error);
			})	
		}		
	}

  function selectTreeTopic(obj) {
    if(obj && obj.hasOwnProperty('children')){
      if(obj && obj.topicId>0){
        setTreeTopicObj(obj);
      }   
    }else{
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Save tree before continue");
    }
  }

  function copyFrom(){
    childRefCopyFrom.current.handleClickOpen();
  }

  // function createCache(){
  //   props.createCache();
  //   setOpen(false);
  // }

  // function saveBtnActive(){
  //   ///setSaveBtn(true);
  // }

  //****************************************************************/
  function sortTree(arr, key, ascending = true) {
    arr.sort((a, b) => {
      if (a[key] < b[key]) {
        return ascending ? -1 : 1;
      } else if (a[key] > b[key]) {
        return ascending ? 1 : -1;
      } else {
        return 0;
      }
    });
  
    // Recursively sort children if they exist
    for (let item of arr) {
      if (item.children) {
        sortTree(item.children, key, ascending);
      }
    }
  
    return arr;
  }

  const addNode = (parentId, newNode) => {    
    if(parentId && parentId>0 && newNode){
      ///alert(JSON.stringify(newNode));
      const updatedTreeData = updateTreeAdd(tempTreeview, parentId, newNode);
      setTempTreeview(updatedTreeData);
    }else if(newNode){
      tempTreeview.push(newNode);
      setTempTreeview(tempTreeview);
      setIdNum(idNum+1);
    }
    ///console.log(JSON.stringify(tempTreeview));
  };

  const updateTreeAdd = (nodes, parentId, newNode) => {
    return nodes.map(node => {
      if (node.id === parentId && newNode) {        
        node.children.push(newNode);
        setIdNum(idNum+1);
      } else if (node.children) {
        node.children = updateTreeAdd(node.children, parentId, newNode);
      }
      return node;
    });
  };

  // function editNodeTopic(){
  //   editNode({id: treeTopicObj.id, title: "Just Edited", display: 0, sequence: 1});
  // }

  const editNode = (obj) => {
    if(obj.id && obj.id>0){
      const updatedTreeData = updateTreeEdit(tempTreeview, obj);
      setTempTreeview(updatedTreeData);
      ///updateCache(); //update cache in DB after edit
    }
  };
  const updateTreeEdit = (nodes, obj) => {
    return nodes.map(node => {
      if (node.id === obj.id) {        
        node.title=obj.title;
        node.display=obj.display;
        node.sequence=obj.sequence;        
      } else if (node.children) {
        node.children = updateTreeEdit(node.children, obj);
      }
      return node;
    });
  };

  const delNode = (id) => {
    const updatedTreeData = removeObjectFromTree(tempTreeview, id);
    setTempTreeview(updatedTreeData);
  };

  function removeObjectFromTree(tree, id) {
    return tree.reduce((result, node) => {
      if (node.id!==id) {
        // If the node passes the filter, include it in the result
        if (node.children) {
          // If the node has children, recursively filter them
          node.children = removeObjectFromTree(node.children, id);
        }
        result.push(node);
      }
      return result;
    }, []);
  }

  // function checkNodeExists(tree, targetValue) {    
  //   if (tree === null || tree === undefined) {
  //     return false;
  //   }
  //   let retrn = false;
  //   tree.map(node => {
  //     ///alert('AAA == '+node.topicName);
  //     if (node.topicName === targetValue) {        
  //       retrn = true;
  //     } else if (node.children) {
  //       node.children = checkNodeExists(node.children, targetValue);
  //     }
  //   });
  //   return retrn;
  // }

  //console.log(tempTreeview);
  
  return (
    <>
      <Dialog fullScreen style={{margin:10}} maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
              <div className="btmbdrgry"><h3>{props.dataObj?props.dataObj.templateName:null}: Treeview</h3></div>
          <Box mt={2}>
          {pageLoading?<LinearProgress />:null}
							<Grid container spacing={2}>
								<Grid item md={6} xs={12} className='topicBox' >  
                    <TextField onChange={event => setKeyword(event.target.value)} value={keyword} placeholder={'Search'} fullWidth size="small" variant="outlined" />
                    <List component="nav" style={{maxHeight: '74vh', overflow: 'auto'}} aria-label="secondary mailbox folder">
                     {rows?rows.filter(obj => obj.topicName.toLowerCase().startsWith(keyword.toLowerCase())).map((row,i)=>(
                        <ListItemButton
                          selected={selectedIndex === i}
                          onClick={(event) => handleListItemClick(event, i, row)}
                          key={'t'+i}
                        >
                            {selectedIndex === i?
                              <ListItemIcon>
                                <CheckIcon />
                              </ListItemIcon>
                            :null}  
                            <ListItemText primary={row.topicName} />
                        </ListItemButton>
                      )):null}                      
                    </List>                    
                </Grid>
                <Grid item md={6} xs={12}>
                    {(treeTopicObj && treeTopicObj.title && treeTopicObj.title.length>0)?<div style={{padding: 10, backgroundColor:'#498ce4',color:'#FFF',fontWeight:'bold',marginBottom:10}} >Selected Topic: {treeTopicObj.title}</div>:null}           
                    {(tempTreeview && tempTreeview.length>0)?<>
                      <TreeViewTopics treeViewData={sortTree(tempTreeview, "sequence")} selectTreeTopic={selectTreeTopic} />
                      </>
                    :null}
                </Grid>
              </Grid>

          </Box>      

            

                      {/* <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          {saveLoading?
                          <LoadingButton loading={saveLoading} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Save</LoadingButton>
					    	          :
                          <Button onClick={() => {saveData()}} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Save</Button>
                          }
                      </Box> */}

          </DialogContent>
          <DialogActions>

          {(tempTreeview && tempTreeview.length>0)?<>
            {uplineFlagLoading?<LoadingButton loading={uplineFlagLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#008000',color:'#FFF'}} size="small" variant="contained"  >Tree Saving...</LoadingButton>
            :<Button onClick={()=>{updateUDFlag()}} size='small' color='primary' variant="contained" >Save Tree</Button>}  
          </>:null}
          <Button onClick={handleClose}>Cancel</Button>
          {addBtnLoading?<LoadingButton loading={addBtnLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#008000',color:'#FFF'}} size="small" variant="contained"  >Adding</LoadingButton>:
          (selectedIndex>-1 && rows[selectedIndex].autoId)?<>
          <Button onClick={()=>{addTopic()}}>Add</Button>
          {/* <CheckAvailability variant={''} topicId={(topicListObj && topicListObj.autoId>0)?topicListObj.autoId:0} /> */}
          <CheckAvailability topicId={(topicListObj && topicListObj.autoId>0)?topicListObj.autoId:0} topicName={(topicListObj && topicListObj.autoId>0)?topicListObj.topicName:''} treeviewTemplateId={props.dataObj.autoId} variant="" />
   
          </>
          :null}
          {(tempTreeview && tempTreeview.length>0 && treeTopicObj && treeTopicObj.title && treeTopicObj.title.length>0)?<>
            <Button title='Copy node from other template' onClick={()=>{copyFrom()}}>Copy-from</Button>
          <Button onClick={()=>{unselectTopic()}}>Unselect</Button> 
          <Button onClick={()=>{editTopic()}}>Edit</Button>
          {/* <Button onClick={()=>{editNodeTopic()}}>Update OK</Button> */}
          <Button onClick={()=>{setDeleteDialogShow(true)}}>Remove</Button>
          </>:null}
        </DialogActions>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

        <Dialog
					open={deleteDialogShow}
					onClose={()=>{setDeleteDialogShow(false)}}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to remove tree node.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{setDeleteDialogShow(false)}}>Don't Remove</Button>
					                {deleteBtnLoading?
                          <LoadingButton loading={deleteBtnLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#f60057',color:'#FFF'}} size="small" variant="contained"  >Removing</LoadingButton>
					    	          :<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteTopic()}} autoFocus>Yes, Remove</Button>
                          }
					</DialogActions>
				</Dialog>
        
        {/* <TempTopicDisplayNames dataObj={treeTopicObj} tempTreeview={setTempTreeview} ref={childRefDisplayNames} /> */}
        {/* <TempTopicSave dataObj={treeTopicObj} tempTreeview={setTempTreeview} saveBtnActive={saveBtnActive} ref={childRefSave} /> */}
        <TempTopicSave dataObj={treeTopicObj} editNode={editNode} ref={childRefSave} />

        <TreeCopyFromSave dataObj={treeTopicObj} tempTreeview={setTempTreeview} ref={childRefCopyFrom} />              

    </>
  );

});

export default CustomizedDialogs;